<!-- HTML -->
<template>
  <div>
    <!-- Background & Fog -->
    <div id="home-header">
      <div class="fog-container">
        <div class="fog-img fog-img-1"></div>
        <div class="fog-img fog-img-2"></div>
      </div>
      <!-- Header Section -->
      <HomeHeader />
      <!-- Audio Player Section -->
      <HomeAudio />
    </div>
    <!-- Home Digital Download Section -->
    <HomeDigiDownload />
    <!-- Barbed Wire Hand Section -->
    <HomeBarbedWireHand />
    <!-- About Section -->
    <HomeAbout />
    <!-- Mailing List Section -->
    <HomeMailingList />
    <!-- Albums Section -->
    <HomeFeaturedStore />
    <!-- Footer Section -->
    <HomeFooter />
  </div>
</template>

<!-- JavaScript -->
<script>
// @ is an alias to /src
import HomeHeader from "@/components/home/HomeHeader.vue";
import HomeAudio from "@/components/home/HomeAudio.vue";
import HomeDigiDownload from "@/components/home/HomeDigiDownload.vue";
import HomeBarbedWireHand from "@/components/home/HomeBarbedWireHand.vue";
import HomeAbout from "@/components/home/HomeAbout.vue";
import HomeFeaturedStore from "@/components/home/HomeFeaturedStore.vue";
import HomeMailingList from "@/components/home/HomeMailingList.vue";
import HomeFooter from "@/components/home/HomeFooter.vue";

export default {

  name: "Home",

  components: {

    HomeHeader,
    HomeAudio,
    HomeDigiDownload,
    HomeBarbedWireHand,
    HomeAbout,
    HomeFeaturedStore,
    HomeMailingList,
    HomeFooter

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
@import "../assets/scss/transitions.scss";

#home-header {
  background-image: url("../assets/img/home/bg-coal-plant.jpg");
  font-family: "astera";
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: local;
  background-size: cover;
}

// Fog
.fog-container {
  position: absolute;
  height: 200vh;
  width: 100%;
  overflow: hidden;
}
.fog-img {
  position: absolute;
  height: 100%;
  width: 300vw;
}
.fog-img-1 {
  background: url("../assets/img/home/fog-1.png") repeat-x;
  background-size: contain;
  background-position: center;
  animation: marquee 80s linear infinite;
}
.fog-img-2 {
  background: url("../assets/img/home/fog-2.png") repeat-x;
  background-size: contain;
  background-position: center;
  animation: marquee 40s linear infinite;
}
@keyframes marquee {
  0% {
    transform: translate3d(-200vw, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
</style>
